export enum LayerTypesEnum {
  Vector,
  XYZ,
  WMS,
  WMTS,
  TILES3D,
  QUANTIZEDMESH,
}
